import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Routes, RouterModule} from '@angular/router';

import {AppComponent} from 'src/app/app.component';
import {AuthService} from 'src/app/utility/auth/auth.service';

import {APICreateComponent, APIListComponent, APIDummyComponent, APIOwnerListComponent, APIOwnerDetailComponent} from '@serengeti/serengeti-api-manager';

const routes: Routes = [
  {
    path: 'main', component: AppComponent, canActivate: [AuthService], children: [
      { path: 'api/list/:apiType', component: APIListComponent, outlet: 'content', data: { title: 'api.list.title', root: true}},
      { path: 'api/create/:apiType', component: APICreateComponent, outlet: 'content', data: { title: 'api.create.title', root: true}},
      { path: 'api/owner/list', component: APIOwnerListComponent, outlet: 'content', data: { title: 'api.owner.title', root: true}},
      { path: 'api/owner/detail/:id', component: APIOwnerDetailComponent, outlet: 'content', data: { title: 'api.owner.title', root: true}},
      { path: 'api/dummy/list', component: APIDummyComponent, outlet: 'content', data: { title: 'api.dummy.title', root: true}},
    ]
  },
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload', useHash: true}),
    CommonModule
  ]
})
export class AppRoutingApiManagerModule {
}
